<template>
  <div class="as-content-page">
    <filter-tags
      :tags="tags"
      :leagues="leagues"
      :sortBy="sortBy"
      :filter="filter"
      @changeTag="(newVal) => changeTag(newVal)"
      @changeLeague="(newVal) => changeLeague(newVal)"
      @sorByTime="(newVal) => sorByTime(newVal)"
      page="result"
    />
    <div
      v-if="filter.league && rounds.length"
      :class="`as-league-rounds as-league-rounds-${gSiteName}`"
    >
      <h5>Vòng đấu</h5>
      <a
        v-for="round in rounds"
        :key="round"
        href="javascript:void(0)"
        rel="nofollow"
        data-round="1"
        class="load-round-data"
        :class="{
          active: roundNumberActive == round,
        }"
        @click="() => changeRoundNumber(round)"
        >{{ round }}</a
      >
    </div>
    <div v-if="isLoading" class="as-py-24">
      <MatchsSkeleton />
    </div>
    <Matches
      v-else-if="competitions.length > 0"
      :competitions="competitions"
      :filter="filter"
      :competitionType="competitionType"
      :isLoadMoreInverse="isLoadMoreInverse"
      :isLoadInverse="isLoadInverse"
      @loadInverse="matchInverse"
    />
    <NoData v-else />
  </div>
</template>

<script>
import { defineComponent, toRaw } from "vue";
import { format, subDays } from "date-fns";
import FilterTags from "~src/components/FilterTags.vue";
import Matches from "~src/modules/result/components/Matches.vue";
import MatchsSkeleton from "~src/components/skeleton/result/MatchsSkeleton.vue";
import NoData from "~src/components/NoData.vue";
import { parseMatchData, parseCompetitionData } from "~src/helpers";
import {
  competitionFeatured,
  matchRecent,
  matchRecentInverse,
  seasonMatches,
} from "~src/services/SpapiService";
import MatchEnum from "~src/enums/MatchEnum";
import CompetitionEnum from "~src/enums/CompetitionEnum";
export default defineComponent({
  name: "resultHome",
  components: {
    FilterTags,
    Matches,
    MatchsSkeleton,
    NoData,
  },
  props: {
    competitionId: {
      type: String,
    },
    roundNum: {
      type: String,
    },
  },
  data() {
    const tags = [];
    for (let i = 0; i < 8; i++) {
      tags.push({
        title: i === 0 ? "Hôm nay" : format(subDays(new Date(), i), "dd/MM"),
        value: format(subDays(new Date(), i), "yyyy-MM-dd"),
      });
    }

    return {
      tags,
      leagues: [],
      matchs: [],
      competitions: [],
      isLoading: false,
      sortBy: "league",
      competitionType: 0,
      roundNumberActive: 0,
      rounds: [],
      filter: {
        tag: tags[0],
        league: null,
      },
      isLoadMoreInverse: false,
      isLoadInverse: false,
      hasCalledMatchInverse: false,
    };
  },
  async created() {
    const rs = await competitionFeatured();
    // this.leagues = decryptData(rs.data.data);
    this.leagues = rs.data.data;

    if (this.competitionId) {
      const league = this.leagues.find(
        (item) => item.id === this.competitionId
      );
      if (league) {
        this.filter = {
          ...this.filter,
          tag: null,
          league,
        };

        if (this.roundNum) {
          this.roundNumberActive = this.roundNum;
        }
        await this.getSeasonMatches(league.cur_season_id, false);
      } else {
        await this.getMatch();
      }
    } else {
      await this.getMatch();
    }
  },
  methods: {
    async formatMatch() {
      let matchs = toRaw(JSON.parse(JSON.stringify(this.matchs)));
      let competitions = toRaw(JSON.parse(JSON.stringify(this.competitions)));
      if (this.sortBy === "time") {
        matchs.sort((a, b) => b.match_time - a.match_time);
      } else if (this.filter.tag && this.sortBy === "league") {
        // matchs.sort(
        //   (a, b) => b.competition.popularity - a.competition.popularity
        // );
        const dataSort = [];
        for (const league of this.leagues) {
          const ms = matchs.filter((item) => item.competition_id === league.id);
          dataSort.push(...ms);
        }
        for (const match of matchs) {
          const checkNot = this.leagues.find(
            (item) => item.id === match.competition_id
          );
          if (!checkNot) {
            dataSort.push(match);
          }
        }
        matchs = dataSort;
      }
      const datas = [];

      for (const match of matchs) {
        const competition = competitions
          ? competitions.find((item) => item.id === match.competition_id)
          : match.competition;
        if (this.filter.tag && MatchEnum.STATUS_END !== match.status_id) {
          continue;
        }

        let check = true;
        if (this.filter.league && this.roundNumberActive) {
          if (this.competitionType === CompetitionEnum.TYPE_LEAGUE) {
            if (
              !match.round ||
              this.roundNumberActive != match.round?.round_num
            ) {
              check = false;
            }
          } else {
            if (!match.stage || (this.roundNumberActive != match.stage.name && this.roundNumberActive != match.stage.name_vi)) {
              check = false;
            }
          }
        }

        if (check) {
          if (this.sortBy === "time") {
            if (datas.length) {
              if (datas[datas.length - 1].id === match.competition_id) {
                datas[datas.length - 1].matchs.push(match);
              } else {
                datas.push({
                  ...competition,
                  matchs: [match],
                });
              }
            } else {
              datas.push({
                ...competition,
                matchs: [match],
              });
            }
          } else {
            const index = datas.findIndex(
              (item) => item.id === match.competition_id
            );
            if (index !== -1) {
              datas[index].matchs.push(match);
            } else {
              datas.push({
                ...competition,
                matchs: [match],
              });
            }
          }
        }
      }
      this.competitions = datas;
    },
    async getMatch(date = null) {
      this.isLoading = true;
      const rs = await matchRecent(date ? date : this.tags[0].value);
      this.matchs = parseMatchData(rs.data.data.matches);
      this.competitions = parseCompetitionData(rs.data.data.competitions);
      // this.matchs = rs.data.data;

      // bỏ matchRecentInverse
      // if (this.matchs.length === 600) {
      //   this.isLoadInverse = true;
      //   this.hasCalledMatchInverse = false;
      // }

      await this.formatMatch();
      this.isLoading = false;
    },
    async matchInverse() {
      if (!this.filter.tag || this.hasCalledMatchInverse) {
        return;
      }
      this.isLoadMoreInverse = true;
      const rs = await matchRecentInverse(this.filter.tag.value);
      this.matchs = [
        ...this.matchs,
        // ...decryptData(rs.data.data)
        ...rs.data.data,
      ];
      // this.matchs = rs.data.data;
      await this.formatMatch();
      this.isLoadMoreInverse = false;
      this.isLoadInverse = false;
    },
    async getSeasonMatches(seasonId) {
      this.competitionType = 0;
      this.isLoading = true;
      const rs = await seasonMatches(seasonId);
      // const matchs = decryptData(rs.data.data);
      const matchs = rs.data.data.matches;
      const competitions = rs.data.data.competitions;
      if (matchs.length) {
        this.competitionType = competitions[0]?.type;
      }
      this.matchs = matchs;
      this.competitions = competitions;
      await this.getRounds();
      await this.formatMatch();
      this.isLoading = false;
    },
    async changeTag(newVal) {
      this.rounds = [];
      this.roundNumberActive = 0;
      this.filter = {
        tag: newVal,
        league: null,
      };
      await this.getMatch(newVal.value);
    },
    async changeLeague(newVal) {
      this.rounds = [];
      this.roundNumberActive = 0;
      this.filter = {
        tag: null,
        league: newVal,
      };
      await this.getSeasonMatches(newVal.cur_season_id);
    },
    async getRounds() {
      const roundData = [];
      let roundActive = null;
      let roundActiveTime = 0;
      for (const match of this.matchs) {
        if (
          MatchEnum.LIST_STATUS_RESULT.includes(match.status_id) &&
          roundActiveTime < match.match_time
        ) {
          roundActiveTime = match.match_time;
          if (this.competitionType === CompetitionEnum.TYPE_LEAGUE) {
            roundActive = match.round.round_num;
          } else {
            roundActive = match.stage.name_vi ? match.stage.name_vi : match.stage.name;
          }
        }
        if (match.stage) {
          if (this.competitionType === CompetitionEnum.TYPE_LEAGUE) {
            if (!roundData.includes(match.round.round_num)) {
              roundData.push(match.round.round_num);
            }
          } else {
            if (!roundData.includes(match.stage.name_vi ? match.stage.name_vi : match.stage.name)) {
              roundData.push(match.stage.name_vi ? match.stage.name_vi : match.stage.name);
            }
          }
        }
      }
      this.roundNumberActive = roundActive;
      this.rounds =
        this.competitionType === CompetitionEnum.TYPE_LEAGUE
          ? roundData.sort((a, b) => a - b)
          : roundData;
    },
    async changeRoundNumber(newVal) {
      this.roundNumberActive = newVal;
      this.isLoading = true;
      // this.competitions = [];
      await this.formatMatch();
      this.isLoading = false;
    },
    async sorByTime(newVal) {
      this.sortBy = newVal;
      this.isLoading = true;
      // this.competitions = [];
      // if(newVal == 'time') {
      //   this.matchInverse();
      //   this.hasCalledMatchInverse = true;
      // }
      await this.formatMatch();
      this.isLoading = false;
    },
  },
});
</script>

<style scoped></style>
